import { TSellerProfileClient } from 'types/TSellerProfile';

import fetchAPI from '../utils/fetchAPI';

type TParams = {
  sellerId: number;
  requestExternalReviews?: boolean;
  showExtendedAsq?: boolean;
  sellerName?: string;
  postCode?: string;
};

export default function getSellerProfile({
  sellerId,
  requestExternalReviews,
  showExtendedAsq,
  sellerName,
  postCode,
}: TParams): Promise<TSellerProfileClient> {
  try {
    const query = new URLSearchParams();
    if (requestExternalReviews) {
      query.set('reviews', 'external');
    }
    if (showExtendedAsq) {
      query.set('asqType', 'extended');
    }
    if (sellerName) {
      query.set('sellerName', sellerName);
    }
    if (postCode) {
      query.set('postCode', postCode);
    }
    return fetchAPI({
      url: `/v/api/seller-profile/${encodeURIComponent(sellerId)}${query.size ? `?${query.toString()}` : ''}`,
    });
  } catch {
    return Promise.resolve({}) as Promise<TSellerProfileClient>;
  }
}
